function filterButton() {
  var filterForm = document.getElementById("filterShow");
  filterForm.classList.toggle("d-none");
}

function appointmentFilterFunction() {
  var table = document.querySelectorAll(".filterTable tr:not(.header)");
  var input = document.querySelector("#filterSearch").value;
  var regex = new RegExp(input, "i");
  var isFoundInTd = (td) => regex.test(td.innerHTML);
  var isFound = (childrenArr) => childrenArr.some(isFoundInTd);
  var setTrStyleDisplay = ({ style, children }) => {
    style.display = isFound([
      ...children, // <-- All columns
    ])
      ? ""
      : "none";
  };

  table.forEach(setTrStyleDisplay);
}

function closeSchedulerModal() {
  $("#schedulerModal").modal("hide");
}

function htmlToCSV(html, filename) {
  var data = [];
  var rows = document.querySelectorAll("table tr");

  for (var i = 0; i < rows.length; i++) {
    var row = [],
      cols = rows[i].querySelectorAll("td, th");

    for (var j = 0; j < cols.length; j++) {
      row.push(cols[j].innerText.replace(",", " "));
    }

    data.push(row.join(","));
  }

  downloadCSVFile(data.join("\n"), filename);
  location.reload();
}

function downloadCSVFile(csv, filename) {
  var csv_file, download_link;

  csv_file = new Blob([csv], { type: "text/csv" });

  download_link = document.createElement("a");

  download_link.download = filename;

  download_link.href = window.URL.createObjectURL(csv_file);

  download_link.style.display = "none";

  document.body.appendChild(download_link);

  download_link.click();
}

function exportCSV() {
  var hideColumn = document
    .querySelectorAll("table .export-hide-column")
    .forEach((e) => e.remove());
  var html = document.getElementById("appointmentTable").outerHTML;
  htmlToCSV(html, "appointments.csv");
}

function close_window() {
  if (confirm("Close Window?")) {
    close();
  }
}

function exportPaymentCSV() {
  var hideColumn = document
    .querySelectorAll("table .export-hide-column")
    .forEach((e) => e.remove());
  var html = document.getElementById("paymentTable").outerHTML;
  htmlToCSV(html, "Payments.csv");
}
